import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ConfettiCelebration = ({ trigger = false, onComplete = () => { } }) => {
    const [particles, setParticles] = useState([]);
    const [showMessage, setShowMessage] = useState(false);

    useEffect(() => {
        if (trigger) {
            // Generate confetti particles
            const colors = ['#10b981', '#06b6d4', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6'];
            const newParticles = Array.from({ length: 60 }, (_, i) => ({
                id: i,
                x: Math.random() * 100,
                y: -10,
                rotation: Math.random() * 360,
                color: colors[Math.floor(Math.random() * colors.length)],
                size: Math.random() * 8 + 4,
                delay: Math.random() * 0.5,
                duration: Math.random() * 2 + 2,
                drift: (Math.random() - 0.5) * 40,
                shape: Math.random() > 0.5 ? 'circle' : 'rect',
            }));
            setParticles(newParticles);
            setShowMessage(true);

            // Clean up after animation
            const timer = setTimeout(() => {
                setParticles([]);
                setShowMessage(false);
                onComplete();
            }, 4000);

            return () => clearTimeout(timer);
        }
    }, [trigger]);

    if (!trigger && particles.length === 0) return null;

    return (
        <div className="fixed inset-0 pointer-events-none z-[200]">
            {/* Confetti particles */}
            {particles.map((p) => (
                <motion.div
                    key={p.id}
                    initial={{
                        left: `${p.x}%`,
                        top: '-10px',
                        rotate: 0,
                        opacity: 1,
                    }}
                    animate={{
                        top: '120%',
                        left: `${p.x + p.drift}%`,
                        rotate: p.rotation + 720,
                        opacity: [1, 1, 0],
                    }}
                    transition={{
                        duration: p.duration,
                        delay: p.delay,
                        ease: 'easeIn',
                    }}
                    style={{
                        position: 'absolute',
                        width: p.size,
                        height: p.shape === 'circle' ? p.size : p.size * 0.6,
                        backgroundColor: p.color,
                        borderRadius: p.shape === 'circle' ? '50%' : '2px',
                    }}
                />
            ))}

            {/* Celebration Message */}
            <AnimatePresence>
                {showMessage && (
                    <motion.div
                        initial={{ scale: 0, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0, opacity: 0 }}
                        transition={{ type: 'spring', damping: 15, stiffness: 200, delay: 0.3 }}
                        className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-auto"
                    >
                        <div className="bg-[#0F131F]/95 border border-emerald-500/30 backdrop-blur-xl rounded-3xl px-10 py-8 text-center shadow-2xl shadow-emerald-500/20">
                            <div className="text-5xl mb-3">🎉</div>
                            <h2 className="text-2xl font-bold text-white mb-2">Milestone Achieved!</h2>
                            <p className="text-slate-400 text-sm">You're making incredible progress. Keep going!</p>
                            <div className="mt-4 flex items-center justify-center gap-2">
                                <span className="text-xs font-mono text-emerald-400 bg-emerald-500/10 px-3 py-1 rounded-full">
                                    +50 XP Earned
                                </span>
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default ConfettiCelebration;
